import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams  } from "react-router-dom";
import SummaryTab from "./tabs/SummaryTab";
import FinancialDataTab from "./tabs/FinancialDataTab";
import FinancialIndicatorTab from "./tabs/FinancialIndicatorTab";
import IndustryInformationTab from "./tabs/IndustryInformationTab";
import FinancialResultsSummaryTab from "./tabs/FinancialResultsSummaryTab";
import ForecastTab from "./tabs/ForecastTab";
import IRReportsTab from "./tabs/IRReportsTab";
import DividendsTab from "./tabs/DividendsTab";
import { saveAccessLog } from "../utils/commonUtils";
import { useDashboardContext } from "../../context/DashboardContext";

const TabContent = ({ setSecCodeChanged, companyInfo }) => {
    const navigate = useNavigate();
    const { secCode, page } = useParams(); // URL から secCode と page（タブ情報）を取得
    const [searchParams, setSearchParams] = useSearchParams(); // クエリパラメータ
    
    const { state: dashboardState } = useDashboardContext(); // Context から取得

    // URL に指定されたタブ（page）があれば、それをデフォルトのタブにする
    const [activeTab, setActiveTab] = useState(page || "Summary");

    // タブの切り替え
    const openTab = (tabName) => {
        // 現在のURLのパスを取得
        const pathSegments = window.location.pathname.split("/").filter(Boolean);
        let newUrl;
    
        // `/analysis/:secCode/` のパターン（3つのセグメントがある場合）
        if (pathSegments.length === 3 && pathSegments[0] === "analysis") {
            newUrl = `/analysis/${pathSegments[1]}/${tabName}`;
        } else {
            newUrl = `/${pathSegments[0]}`;
        }

        // URLを更新
        navigate(newUrl);
    
        // アクティブタブを設定
        setActiveTab(tabName);
    
        // アクセスログを保存
        saveAccessLog(`dashboard - ${dashboardState.secCode} tab: ${tabName}`);
    };

    
    useEffect(() => {
        const pathSegments = window.location.pathname.split("/").filter(Boolean);
        const currentTab = pathSegments[2];  // `/analysis/:secCode/:tabName` なら 3番目がタブ名

        // タブが指定されていない場合のみSummaryにリダイレクト
        if (pathSegments.length === 2 && pathSegments[0] === "analysis") {
            navigate(`/analysis/${dashboardState.secCode}/Summary`);
            setActiveTab('Summary');
        } else if (currentTab) {
            setActiveTab(currentTab);  // URLにタブが指定されている場合はそのタブをアクティブに
        }
    }, [window.location.pathname]);  // パスの変更も監視
        
    useEffect(() => {
        const pathSegments = window.location.pathname.split("/").filter(Boolean);
        const currentTab = pathSegments[2];  // `/analysis/:secCode/:tabName` なら 3番目がタブ名

        // タブが指定されていない場合のみSummaryにリダイレクト
        if (pathSegments.length === 3 && pathSegments[0] === "analysis") {
            navigate(`/analysis/${dashboardState.secCode}/Summary`);
            setActiveTab('Summary');
        } else if (currentTab) {
            setActiveTab('Summary');  // URLにタブが指定されている場合はそのタブをアクティブに
        }
    }, [dashboardState.secCode]);  // パスの変更も監視
            
    
    if (activeTab === null) return null;

    return (
        <div className="flex flex-col">
            <div className="tab">
                <button className={`tablinks ${activeTab === "Summary" ? "active" : ""}`} onClick={() => openTab("Summary")}>
                    サマリ
                </button>
                <button className={`tablinks ${activeTab === "FinancialData" ? "active" : ""}`} onClick={() => openTab("FinancialData")}>
                    業績推移
                </button>
                <button className={`tablinks ${activeTab === "Dividends" ? "active" : ""}`} onClick={() => openTab("Dividends")}>
                    配当情報
                </button>
                <button className={`tablinks ${activeTab === "IndustryInformation" ? "active" : ""}`} onClick={() => openTab("IndustryInformation")}>
                    業界情報
                </button>
                <button className={`tablinks ${activeTab === "FinancialResultsSummary" ? "active" : ""}`} onClick={() => openTab("FinancialResultsSummary")}>
                    AI 決算サマリ
                </button>
                <button className={`tablinks ${activeTab === "IRReports" ? "active" : ""}`} onClick={() => openTab("IRReports")}>
                    IR / リリース
                </button>
            </div>

            {/* 各タブの表示を `activeTab` に応じて切り替える */}
            {activeTab === "Summary" && (
                <SummaryTab 
                    secCode={dashboardState.secCode ? dashboardState.secCode: secCode} 
                    companyInfo={companyInfo}
                />    
            )}
            {activeTab === "FinancialData" && (
                <FinancialDataTab
                    secCode={dashboardState.secCode ? dashboardState.secCode: secCode}
                />
            )}
            {activeTab === "Dividends" && (
                <DividendsTab secCode={dashboardState.secCode ? dashboardState.secCode: secCode} companyInfo={companyInfo}/>
            )}
            {activeTab === "IndustryInformation" && (
                <IndustryInformationTab
                    secCode={secCode ? secCode : dashboardState.secCode}
                    country={searchParams.get("country")}
                    xaxis={searchParams.get("xaxis")}
                    yaxis={searchParams.get("yaxis")}
                />
            )}
            {activeTab === "FinancialResultsSummary" && (
                <FinancialResultsSummaryTab secCode={dashboardState.secCode ? dashboardState.secCode: secCode} annualQuarter={searchParams.get("annualQuarter")} />
            )}
            {activeTab === "IRReports" && <IRReportsTab secCode={dashboardState.secCode ? dashboardState.secCode: secCode} />}
        </div>
    );
};

export default TabContent;
